import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const phoneNumber = "+256740825445";
  const message = "Hello! I'm interested in BioHaz Waste Solutions services. Can you please help me?";
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      {/* WhatsApp Button */}
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-[#25D366] hover:bg-[#128C7E] text-white p-3 sm:p-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 animate-pulse-slow hover-glow"
        >
          <div className="relative w-5 h-5 sm:w-6 sm:h-6">
            <MessageCircle className={`w-5 h-5 sm:w-6 sm:h-6 absolute transition-all duration-300 ${isOpen ? 'opacity-0 rotate-180' : 'opacity-100 rotate-0'}`} />
            <X className={`w-5 h-5 sm:w-6 sm:h-6 absolute transition-all duration-300 ${isOpen ? 'opacity-100 rotate-0' : 'opacity-0 -rotate-180'}`} />
          </div>
        </button>
      </div>

      {/* WhatsApp Chat Widget */}
      <div className={`fixed bottom-16 right-4 sm:bottom-24 sm:right-6 z-50 bg-white rounded-lg shadow-2xl border max-w-xs sm:max-w-sm w-72 sm:w-80 transition-all duration-500 transform ${
        isOpen ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-4 pointer-events-none'
      }`}>
        <div className="bg-[#075E54] text-white p-3 sm:p-4 rounded-t-lg">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 rounded-full flex items-center justify-center animate-pulse-slow">
              <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
            </div>
            <div>
              <h3 className="font-semibold text-sm sm:text-base">BioHaz Waste Solutions</h3>
              <p className="text-xs sm:text-sm opacity-90">Typically replies instantly</p>
            </div>
          </div>
        </div>
        
        <div className="p-3 sm:p-4">
          <div className="bg-gray-100 rounded-lg p-3 mb-3 sm:mb-4 animate-slide-in-bottom">
            <p className="text-xs sm:text-sm text-gray-700">
              👋 Hello! Need help with waste management? 
              <br /><br />
              We're here to assist you with:
              <br />
              ✓ Medical waste disposal
              <br />
              ✓ Emergency cleanup services
              <br />
              ✓ Waste management consulting
              <br />
              ✓ Free quotes & consultations
            </p>
          </div>
          
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-[#25D366] hover:bg-[#128C7E] text-white text-center py-2 sm:py-3 rounded-lg font-semibold transition-all duration-300 text-sm sm:text-base btn-animate hover-glow transform hover:scale-105"
          >
            Start Chat on WhatsApp
          </a>
          
          <p className="text-xs text-gray-500 text-center mt-2">
            Click to continue on WhatsApp
          </p>
        </div>
      </div>
    </>
  );
};

export default WhatsAppWidget;